const data = {
  id: 'b40dc66f-a441-4322-9c60-72f6df0f74fb',
  title: 'Finds the words in the puzzle using pictures',
  subTitle: 'Nhìn tranh và tìm từ',
  type: 'WordPuzzle',
  question: null,
  imageUrl: null,
  audioUrl: null,
  answers: [
    {
      answer: 'bean',
      imageUrl: 'https://cloud.softech.cloud/admin/Uploads/Images/Vocabulary/131236.png',
    },
    {
      answer: 'knock',
      imageUrl: 'https://cloud.softech.cloud/storage/Data/DragAndDropGame/Verb/Level1/2317.jpg',
    },
    {
      answer: 'poppy',
      imageUrl: 'https://cloud.softech.cloud/storage/Data/DragAndDropGame/Noun/Level1/1870.jpg',
    },
  ],
  settings: {
    question: {
      rows: 8,
      columns: 8,
    },
  },
};
export default data;
